export const EXPRESS_EXPIRY_EMAIL = 'express_expired';
export const EXPRESS_CONSENT_VERSION = '2026-09-10';
export const EXPRESS_CONSENT_TEXT = 'אני מאשר/ת לאמפלוי אקספרס להמליץ עליי ולשלוח את קורות החיים שלי למעסיקים';
export const EXPRESS_HISTORY_LIMIT = 10;
export const EXPRESS_INACTIVE_DAYS = 21;
export const EXPRESS_VALIDITY_TEXT = `השירות יינתן ${EXPRESS_INACTIVE_DAYS} יום מהפעילות האחרונה באמפלוי - ניתן לבטל בכל רגע בהגדרות באזור האישי`;
export const EXPRESS_RENEWAL_DAYS = 7;

export type ExpressEvent = {
    id: string;
    at: string;
    action: 'approved' | 'disabled';
    source: string;
    actorId?: number;
    reason?: 'system' | 'user';
    consentVersion?: string;
};

export type ExpressStatus = {
    approved: boolean;
    promptPending: boolean;
    disabledReason: 'system' | 'user' | null;
    hasCV: boolean;
};

export function readExpressHistory(value: unknown): ExpressEvent[] {
    const parsed = typeof value === 'string' ? JSON.parse(value) : value;
    return Array.isArray(parsed) ? parsed : [];
}

export function appendExpressEvent(history: unknown, event: ExpressEvent): ExpressEvent[] {
    return [...readExpressHistory(history), event].slice(-EXPRESS_HISTORY_LIMIT);
}
